import { render, staticRenderFns } from "./ProjectionSlide.vue?vue&type=template&id=206400a4&scoped=true&"
import script from "./ProjectionSlide.vue?vue&type=script&lang=js&"
export * from "./ProjectionSlide.vue?vue&type=script&lang=js&"
import style0 from "./ProjectionSlide.vue?vue&type=style&index=0&id=206400a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206400a4",
  null
  
)

export default component.exports